var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, type, defaultValue } from "./decorators/type.js";
import { S as SpriteSchema } from "./Sprite-7d2a5fa7.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let ImportantSpriteSchema = class extends SpriteSchema {
  constructor() {
    super(...arguments);
    __publicField(this, "hideInView");
    __publicField(this, "padding");
  }
};
__decorateClass([
  type("boolean"),
  defaultValue(false)
], ImportantSpriteSchema.prototype, "hideInView", 2);
__decorateClass([
  type("number"),
  defaultValue(20)
], ImportantSpriteSchema.prototype, "padding", 2);
ImportantSpriteSchema = __decorateClass([
  Component("ImportantSprite")
], ImportantSpriteSchema);
const __vite_glob_0_26 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ImportantSpriteSchema() {
    return ImportantSpriteSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  ImportantSpriteSchema as I,
  __vite_glob_0_26 as _
};
//# sourceMappingURL=ImportantSprite-329bc41a.js.map
